export default __webpack_public_path__ + "static/media/What_Is_RAMMfunds_Background@2x.8cdcec18.svg";